export const en = {
    'internal-network': 'Internal network',
    'invalid-url': 'Invalid URL',
    'is-mobile': 'Mobile device (isMobile)',
    'is-tablet': 'Tablet (isTablet)',
    'is-touch': 'Touch device (isTouch)',
    'is-virused': 'Marked as infected',
    'is-yandex-plus': 'Yandex Plus',
    no: 'No',
    'not-selected': 'Not selected',
    yes: 'Yes'
};
